import { Flex } from 'components/UI/Flex';
import { Select } from 'components/UI/Interactables/Select';
import { MediaQueries } from 'environment';
import { useLanguage } from 'features/hooks/useLanguage';
import { useNavigation } from 'hooks/navigation';
import { useMediaQuery } from 'hooks/utils';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { LanguageType } from 'types/index';
import { NormalTab, NavTab as Tab, Text } from '../Tab.style';

const DICTIONARY = {
	[LanguageType.English]: {
		projects: 'Projects',
		roles: 'Roles',
		settings: 'Settings',
		users: 'Users',
		subscription: 'Subscription',
		project_approval: 'Project Approval',
		profile: 'Profile'
	},
	[LanguageType.Norwegian]: {
		projects: 'Prosjekter',
		roles: 'Roller',
		settings: 'Innstillinger',
		users: 'Brukere',
		subscription: 'Abonnement',
		project_approval: 'Prosjektgodkjenning',
		profile: 'Profil'
	}
};

const tabsProps = {
	width: 19.1,
	min_width: 19.1,
	underline_width: 11.9
};

export function EnterpriseAdminTabs() {
	const { routes, navigate } = useNavigation();

	const language = useLanguage();
	const dictionary = DICTIONARY[language];

	const { enterpriseAdminProjectsFlag, enterpriseAdminRolesFlag, enterpriseAdminSettingsFlag } =
		useFlags();

	const isPhone = useMediaQuery(
		`only screen and ${MediaQueries.minWidth.xs} and ${MediaQueries.maxWidth.sm}`
	);

	const projectsTab = [
		{
			label: dictionary.projects,
			value: routes.enterpriseAdmin.projects
		}
	];
	const rolesTab = [
		{
			label: dictionary.roles,
			value: routes.enterpriseAdmin.roles
		}
	];
	const settingsTab = [
		{
			label: dictionary.settings,
			value: routes.enterpriseAdmin.settings
		}
	];

	const menuTabs = [
		{
			label: dictionary.users,
			value: routes.enterpriseAdmin.users
		},
		...(enterpriseAdminProjectsFlag ? projectsTab : []),
		{
			label: dictionary.subscription,
			value: routes.enterpriseAdmin.subscription
		},
		...(enterpriseAdminRolesFlag ? rolesTab : []),
		...(enterpriseAdminSettingsFlag ? settingsTab : []),
		{
			label: dictionary.project_approval,
			value: routes.enterpriseAdmin.project_approval
		}
	];

	return (
		<Flex>
			{isPhone ? (
				<NormalTab>
					<Select
						title={dictionary.profile}
						className="dropdown-tab"
						items={menuTabs}
						type={select => select.Tab(true)}
						onSelect={item => navigate(item.value as string)}
					/>
				</NormalTab>
			) : (
				menuTabs.map(item => (
					<Tab
						data-testid={'menu-tab_' + item.label}
						to={item.value as string}
						key={item.label}
						{...tabsProps}
					>
						<div>
							<Text>{item.label}</Text>
						</div>
					</Tab>
				))
			)}
		</Flex>
	);
}
